const TOP = 'Top';
const RIGHT = 'Right';
const BOTTOM = 'Bottom';
const LEFT = 'Left';

function getDistProp(position: string = TOP) {
	return `padding${position}`;
}

const paddingLeft = getDistProp(LEFT);
const paddingRight = getDistProp(RIGHT);
const paddingTop = getDistProp(TOP);
const paddingBottom = getDistProp(BOTTOM);

export function getOffsetLeftResponsive({
	offsetX = 0,
	widthWithPadding = 0,
	windowWidth = 0,
}) {
	const isMinusOffset = offsetX < 0;
	const maxWidth = offsetX * 2 + widthWithPadding;

	if (isMinusOffset) {
		return {};
	}

	if (maxWidth >= windowWidth) {
		return {
			[paddingRight]: 0,
			[paddingLeft]: 0,
			textAlign: 'center' as const,
		};
	}

	return {};
}

export function getOffsetRightResponsive({
	offsetX = 0,
	widthWithPadding = 0,
	windowWidth = 0,
}) {
	const isMinusOffset = offsetX < 0;
	const maxWidth = offsetX * 2 + widthWithPadding;

	if (isMinusOffset) {
		return {};
	}

	if (maxWidth >= windowWidth) {
		return {
			[paddingRight]: 0,
			[paddingLeft]: 0,
			textAlign: 'center' as const,
		};
	}

	return {};
}

export function getCenterLeftResponsive({
	widthWithPadding = 0,
	windowWidth = 0,
}) {
	const noDistance = { [paddingLeft]: 0, [paddingRight]: 0 };

	if (widthWithPadding >= windowWidth) {
		return {
			...noDistance,
			textAlign: 'center' as const,
		};
	}

	return {};
}

export function getOffsetTopResponsive({
	offsetY = 0,
	heightWithPadding = 0,
	windowHeight = 0,
}) {
	const maxHeight = offsetY + heightWithPadding;

	if (heightWithPadding >= windowHeight) {
		return {
			[paddingTop]: 0,
			[paddingBottom]: 'auto',
			pointerEvents: 'auto' as const,
			overflowY: 'auto' as const,
		};
	}

	if (maxHeight >= windowHeight) {
		return {
			[paddingTop]: `calc(100vh - ${heightWithPadding}px)`,
			[paddingBottom]: 0,
		};
	}

	return {};
}

export function getCenterTopResponsive({
	offsetY = 0,
	heightWithPadding = 0,
	windowHeight = 0,
}) {
	const maxHeight = offsetY * 2 + heightWithPadding;

	if (maxHeight >= windowHeight) {
		return {
			pointerEvents: 'auto' as const,
			overflowY: 'auto' as const,
		};
	}

	return {};
}

export function getOffsetBottomResponsive({
	offsetY = 0,
	heightWithPadding = 0,
	windowHeight = 0,
}) {
	const maxHeight = offsetY + heightWithPadding;

	if (heightWithPadding >= windowHeight) {
		return {
			[paddingTop]: 0,
			[paddingBottom]: 0,
			pointerEvents: 'auto' as const,
			overflowY: 'auto' as const,
		};
	}

	if (maxHeight >= windowHeight) {
		return {
			[paddingTop]: 0,
			[paddingBottom]: 'auto',
			height: '100%',
		};
	}

	return {};
}
